import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const DesignTools = () => {
  const knowledgeBases = [
    {
      title: "ROM Cost Estimation Framework",
      description: "Rough Order of Magnitude cost estimation tools for federal construction projects",
      type: "Framework",
      lastUpdated: "2024-01-15"
    },
    {
      title: "Project Timeline Generation Tools",
      description: "Automated scheduling and timing analysis for design and construction phases",
      type: "Tool",
      lastUpdated: "2024-02-18"
    },
    {
      title: "Federal Cost Database",
      description: "Historical cost data for materials, labor, and equipment in federal projects",
      type: "Database",
      lastUpdated: "2024-02-25"
    },
    {
      title: "Design Phase Timing Standards",
      description: "Standard durations and dependencies for federal building design phases",
      type: "Standard",
      lastUpdated: "2024-01-20"
    },
    {
      title: "Cost Optimization Algorithms",
      description: "AI-powered tools for optimizing project costs while maintaining quality standards",
      type: "Algorithm",
      lastUpdated: "2024-02-12"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Design Tools: Timing & ROM Cost Generation</h1>
          <p className="text-muted-foreground">
            Comprehensive tools and frameworks for project timing analysis and rough order of magnitude cost estimation in federal building projects.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm">
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default DesignTools;